<template>
  <div class="statements flex xs12 pl-0">
    <v-card elevation="0">
      <v-card-title class="pl-0">
        <h3>{{ $t('L_statements') }}</h3>
      </v-card-title>
      <v-card-text class="pl-0">
        <a
          class="cursor-pointer font-weight-bold blueText"
          color="anchor"
          @click.stop="navigateToDocumentsPage"
          >{{ $t('L_view_investment_statements') }}</a
        >
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions, mapState } from 'pinia';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { RouteNames } from '@/router/routeNames';

export default defineComponent({
  name: 'StatementsComponent',
  data() {
    return {
      statementTitle: null as string | null,
    };
  },
  computed: {
    ...mapState(useCustomerStore, ['loading', 'investments']),
    statements() {
      return this.investments.statements;
    },
    isMobile() {
      return this.$vuetify.display.xs;
    },
  },
  methods: {
    ...mapActions(useCustomerStore, ['openStatement']),
    async navigateToDocumentsPage() {
      try {
        const i = this.$dynatrace.enterAction('link_investmentStatements_investmentDetailsPage');
        this.$dynatrace.leaveAction(i);
      } catch (_error) {
        /* empty */
      }
      await this.$router.push({ name: '' });
      if (this.isMobile) {
        await this.$router.push({
          name: RouteNames.DOCUMENT_LIST_MOBILE,
          params: { routeName: RouteNames.INVESTMENT_STATEMENTS },
        });
      } else {
        await this.$router.push({ name: RouteNames.INVESTMENT_STATEMENTS }); // default
      }
    },
  },
});
</script>

<style lang="scss">
.statements {
  margin: 5px 0 0;
  box-shadow: none;

  .v-expansion-panel {
    box-shadow: none;

    .v-expansion-panel__header {
      color: #063562;
      width: fit-content;
      margin: 0 auto;
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
    }

    .v-icon {
      color: #063562 !important;
      font-size: 32px;
    }

    .v-expansion-panel__body {
      padding: 20px;
      background: #f9f9f9;
    }
  }

  .v-card__title,
  .v-card__text {
    border-bottom: 1px solid #cccccc;
  }

  .v-card__title {
    color: #333333;
    font-size: 24px;
  }

  .v-card__text {
    font-size: 14px;
    text-align: center;

    @media only screen and (min-width: 640px) {
      padding: 20px;
    }
  }
}

.layout {
  padding: 10px 5px;

  @media only screen and (min-width: 640px) {
    padding: 10px 20px;
  }
}

.alternate {
  background-color: #fafcfd;
}

.header {
  &.layout {
    border: none;
    padding: 10px 20px 20px;
  }
}

.period {
  font-weight: 600;
  text-align: left;
}

.statement {
  padding: 0 0 0 15px;
  text-align: left;
  font-weight: 600;
  text-decoration: underline;
}
</style>
